module.exports = __webpack_public_path__ + "media/images/emblems/Plasselb-coat_of_arms-34c9a09867a6694a07122567855d9dcb.svg";